module.exports = __webpack_public_path__ + "front/img/b23.bd3ddbff.jpg";